import * as axios from "axios";
import { generateHeaders } from "../utils/generateHeaders";

const apiURL = process.env.REACT_APP_BACKEND_URL;
export const baseURL = process.env.REACT_APP_BACKEND_URL;

interface ResponseData {
    data: any;
    status: number;
}

function normalizeServerResponse(serverResponse: axios.AxiosResponse): ResponseData {
    return {
        data: serverResponse.data,
        status: serverResponse.status,
    };
}

function normalizeServerError(error: any): ResponseData {
    return {
        data: error.response?.data?.message || error.message,
        status: error.response?.status || 500,
    };
}

// FPO REGISTRATION
export async function dealerRegistration(
    typeOfOrganization: string,
    nameOfFpo: string,
    typeOfFpo: string,
    dateOfFpo: string,
    organizationalEmail: string,
    contactNumber: string,
    promoterName: string,
    password: string
) {
    try {
        const payload = {
            typeOfOrganization,
            nameOfFpo,
            typeOfFpo,
            dateOfFpo,
            organizationalEmail,
            contactNumber,
            promoterName,
            password,
        };

        const headers = generateHeaders();

        const response = await axios.default.post(
            `${baseURL}/fpo`,
            { payload, headers },
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// WhatsApp OTP
export async function sendOtp(phoneNumber: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/whatsapp/send-otp`,
            { phoneNumber },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// check OTP
export async function checkOtp(phoneNumber: string, otp: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/whatsapp/check-otp`,
            { phoneNumber, otp },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// pincode check
export async function checkPincode(pincode: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/farmer/address`,
            { headers, pincode },
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

//change password
export async function changePassword(contactNumber: string, newPassword: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/app/reset-password`,
            { contactNumber, newPassword },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    }
    catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Login
export async function dealerLogin(contactNumber: string, password: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/app/sign-in`,
            { contactNumber, password },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Mobile exists check
export async function mobileExist(contactNumber: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/check-contact/${contactNumber}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Farmer data fetching
export async function fetchFarmer(mobile: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/appFarmer/data/${mobile}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Insights data
export async function insights(selectedCrop: string, dealerNumber: string | null) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/appFarmer/farmers/insight?dealerNumber=${dealerNumber}&crop=${selectedCrop}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// crops fetching
export async function takeCropsList() {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/all/crops`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Crop library data fetching
export async function takeCropDetails(selectedCrop: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/crops/${selectedCrop}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Crop library variety
export async function takeVarietyDetails(selectedCrop: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/varity/${selectedCrop}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// farmer registration
//register farmer
export async function farmer_registration(
    dealerNumber: any,
    name: any,
    whatsappNumber: any,
    totalOwnedFarm: any,
    totalLeaseFarm: any,
    village: any,
    district: any,
    state: any,
    typeOfCultivationPractice: any,
    pincode: any
) {
    console.log("registerFarmer", dealerNumber, name, whatsappNumber, totalOwnedFarm, totalLeaseFarm, village, district, state, typeOfCultivationPractice, pincode);
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/appFarmer/register`,
            {
                dealerNumber,
                name,
                whatsappNumber,
                totalOwnedFarm,
                totalLeaseFarm,
                village,
                district,
                state,
                typeOfCultivationPractice,
                pincode
            },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Bulk uploading farmers
export async function bulkUploadFarmers(farmersData: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/appFarmer/farmer/bulk-upload`,
            farmersData,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

//Mandi Price_state_APi
export async function mandiPrice_state() {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/mandi/filter`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Mandi Price District API
export async function mandiPrice_district(selectedState: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/mandi/filter?stateName=${selectedState}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

//Mandi Price Commodity API
export async function mandiPrice_commodity(selectedState: any, selectedDistrict: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/mandi/filter?stateName=${selectedState}&districtName=${selectedDistrict}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Mandi Price Full API
export async function mandiPrice_full(selectedState: any, selectedDistrict: any, selectedCommodity: any, formattedInitialDate: any, formattedEndDate: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/mandi/mandiPrices?state=${selectedState}&district=${selectedDistrict}&commodity=${selectedCommodity}&initialDate=${formattedInitialDate}&finalDate=${formattedEndDate}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Add Crop Cultivation 
export async function addCropCultivation(dealerNumber: any,
    fid: any, // WhatsApp number (farmer ID)
    farmerName: any,
    crops: any,
    variety: any,
    dateOfSowing: any,
    geolocation: any,
    typeOfCultivationPractice: any,
    areaInAcres: any,
    geoLinkAreaOnMap: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/appFarmer/crop/register`,
            {
                dealerNumber,
                fid,
                farmerName,
                crops,
                variety,
                dateOfSowing,
                geolocation,
                typeOfCultivationPractice,
                areaInAcres,
                geoLinkAreaOnMap
            },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// get all crops under that dealer
export async function getAllCrops_dealer(dealerNumber: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/appFarmer/crops/${dealerNumber}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// get all villages under that dealer
export async function getAllVillages_dealer(dealerNumber: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/appFarmer/villages/${dealerNumber}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

//Market insights 
export async function marketInsights(selectedState: any, selectedDistrict: any, selectedCommodity: any) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/market/market-insight?state=${selectedState}&district=${selectedDistrict}&commodity=${selectedCommodity}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// takeEnquiriesList
export async function takeEnquiriesList() {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/commodity/all/commodities`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

//get enquiries by commodity
export async function getEnquiriesByCommodity(commodity: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/commodities/${commodity}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// get enquiries of a FPO
export async function getEnquiryOfFpo(mobile: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/commodity/${mobile}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

//Post enquiry
export async function postEnquiry(
    uid: string,
    operation: string,
    commodity: string,
    variety: string,
    quantity: string,
    moisture: string,
    localGradeSpecification: string,
    size: string,
    count: string,
    price: string,
    date: string,
    origin: string,
    location: string,
    photoVideoLink: string | null,
    comments: string | null,
) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/commodity`,
            {
                uid,
                operation,
                commodity,
                variety,
                quantity,
                moisture,
                localGradeSpecification,
                size,
                count,
                price,
                date,
                origin,
                location,
                photoVideoLink,
                comments
            },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

export async function postImageToServer(image: any) {
    try {
        const headers = await generateHeaders();
        const formData = new FormData();
        formData.append("image", image); // key must match what your backend expects

        const response = await axios.default.post(
            `${baseURL}/upload`,
            formData,
            {
                headers: {
                    ...headers,
                    "Content-Type": "multipart/form-data", // required
                },
            }
        );

        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Update Enquiry
export async function updateEnquiry(
    _id: string,
    mobile: string,
    operation: string,
    commodity: string,
    variety: string,
    quantity: string,
    moisture: string,
    localGradeSpecification: string,
    size: string,
    count: string,
    price: string,
    date: string,
    origin: string,
    location: string,
    photoVideoLink: string | null,
    comments: string | null
) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.put(
            `${baseURL}/commodities/${mobile}/${_id}`,
            {
                operation,
                commodity,
                variety,
                quantity,
                moisture,
                localGradeSpecification,
                size,
                count,
                price,
                date,
                origin,
                location,
                photoVideoLink,
                comments
            },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// Add to wishlist
export async function addToWishlist(
    _id: string, userId: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.post(
            `${baseURL}/wishlist/add/${_id}`,
            {
                userId
            },
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// get all wishlist
export async function getAllWishlist(userId: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.get(
            `${baseURL}/wishlist/?userId=${userId}`,
            { headers }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}

// delete wishlist item
export async function removeFromWishlist(_id: string, userId: string) {
    try {
        const headers = await generateHeaders();
        const response = await axios.default.delete(
            `${baseURL}/wishlist/remove/${_id}`,
            {
                data: { userId },
                headers
            }
        );
        return [null, normalizeServerResponse(response)];
    } catch (error) {
        return [normalizeServerError(error), null];
    }
}
